<template>
  <view class="station">
    <view class="header" wx:style="{{headerStyle}}">
      <view class="tab tab_left" wx:class="{{ { active_left: isActive === orderArr[0]} }}" bindtap="changeTab(orderArr[0])">{{showTab.left_title}}</view>
      <view class="tab tab_right" wx:class="{{ { active_right: isActive === orderArr[1] } }}" bindtap="changeTab(orderArr[1])">{{showTab.right_title}}</view>
    </view>
    <view class="content">
      <gas-list
        wx:show="{{isActive === 'gas'}}"
        list="{{list}}"
        styleConfig="{{styleConfig}}"
        showFooterBtn="{{showFooterBtn}}"
        bind:toGuide="toGuide"
      />
      <car-wash-list
        wx:show="{{isActive === 'car'}}"
        list="{{carList}}"
        styleConfig="{{styleConfig}}"
        showFooterBtn="{{showFooterBtn}}"
        bind:goToDetail="goToDetail"
      />
      <view wx:if="{{!requested && isActive === 'gas'}}" class="placehoder">
        <view wx:for="{{requestParams.limit}}" wx:key="*this" class="item {{list.length - 1 === index && !showFooterBtn ? 'no-border' : ''}}" wx:style="{{itemStyle}}"></view>
      </view>
      <view wx:if="{{!requestedCar && isActive === 'car' }}" class="placehoder">
        <view wx:for="{{requestParams.limit}}" wx:key="*this" class="item {{carList.length - 1 === index && !showFooterBtn ? 'no-border' : ''}}" wx:style="{{itemStyle}}"></view>
      </view>
      <view class="footer" wx:if="{{showFooterBtn}}">
        <view class="button" bindtap="footerBtnClick(isActive)" wx:style="{{footerBtnStyle}}"> {{isActive === 'gas' ? '查看附近更多油站' : '查看附近更多洗车店'}}
        </view>
      </view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { post, is, bridge, build, xenv, trackEvent } from '@didi/webx-js'

const paramsList = [ 'scene', 'token', 'lat', 'lng' ]
const ERROR = {
  name: 'error',
  requestError: 'requestError',
  networkError: 'networkError',
  paramsError: 'paramsError',
}
const orderMap = {
  'gasFirst': ['gas', 'car'],
  'carFirst': ['car', 'gas']
}
createComponent({
  name: 'gas-station-list',
  properties: {
    gasTitle: {
      type: String,
      value: '附近优惠油站',
    },
    carTitle: {
      type: String,
      value: '附近洗车店'
    },
    showTabOrder: {
      type: String,
      value: 'gasFirst'
    },
    showFooterBtn: {
      type: Boolean,
      value: true,
    },
    params: {
      type: Object,
      value: () => ({})
    },
    styleConfig: {
      type: Object,
      value: {}
    },
  },
  data: {
    list: [],
    carList: [],
    requested: false,
    requestedCar: false,
    error: '',
    isActive: orderMap['gasFirst'][0],
    orderArr: orderMap['gasFirst'],
  },
  computed: {
    showTab() {
      if (this.showTabOrder === 'gasFirst' || this.showTabOrder === undefined) {
        this.orderArr = orderMap[this.showTabOrder]
        this.isActive = orderMap[this.showTabOrder][0]
        return {
          left_title: this.gasTitle,
          right_title: this.carTitle
        }
      } else {
        this.orderArr = orderMap[this.showTabOrder]
        this.isActive = orderMap[this.showTabOrder][0]
        return {
          left_title: this.carTitle,
          right_title: this.gasTitle
        }
      }
    },
    showComponent() {
      return ![ERROR.networkError, ERROR.requestError].includes(this.error)
    },
    requestParams() {
      return {
        app_env: xenv(),
        limit: 1,
        ...this.params
      }
    },
    headerStyle() {
      return { color: this.styleConfig.titleColor, backgroundImage: this.styleConfig.headerImage }
    },
    priceLabelStyle() {
      return { color: this.styleConfig.labelColor }
    },
    priceStyle() {
      return { color: this.styleConfig.priceColor }
    },
    itemStyle() {
      return { borderColor: this.styleConfig.borderColor }
    },
    footerBtnStyle() {
      return { color: this.styleConfig.footerBtnColor }
    },
    footerBtnArrowStyle() {
      return { borderLeftColor: this.styleConfig.footerBtnColor }
    },
  },
  watch: {
    isActive: {
      async handler(newVal, oldVal) {
        await this.checkParams(this.params)
        if (newVal === 'gas') {
          if (this.list.length >0) return
          await this.getGasList()
        }
        if (newVal === 'car') {
          if (this.carList.length >0) return
          await this.getCarList()
        }
      },
      immediate: true,
    }
  },
  ready() {
    this.triggerEvent('stationShow', { tab: this.isActive, title: this.isActive === 'gas' ? this.gasTitle : this.carTitle })
  },
  methods: {
    async changeTab(tab) {
      this.isActive = tab
      this.triggerEvent('changeTab', { tab, title: tab === 'gas' ? this.gasTitle : this.carTitle })
    },
    goToDetail({detail}) {
      this.triggerEvent('goCarWahDetail', { item: detail, title: this.isActive === 'gas' ? this.gasTitle : this.carTitle })
    },
    async getGasList() {
      try {
        this.requested = false
        const res = await post('https://bosp-api.xiaojukeji.com/cyberset/api/oilStation/get', this.requestParams, {
          params: {
            token: this.params.token,
          },
        })
        if (res.errno == 0 && res.data?.station_list?.length) {
          this.list = res.data.station_list.map(item => {
            item.distance_desc = item.distance > 1000 ? `${(item.distance/1000).toFixed(1)}km` : `${item.distance}m`
            return item
          })
        }
        if (res.errno !== 0) {
          this.triggerError(ERROR.requestError, res)
        }
      } catch (e) {
        this.triggerError(ERROR.networkError, e)
        console.error(e)
      }
      this.requested = true
    },
    async getCarList() {
      try {
        this.requestedCar = false
        const res = await post('https://bosp-api.xiaojukeji.com/cyberset/api/carWash/get', this.requestParams, {
          params: {
            token: this.params.token,
          },
        })
        if (res.errno == 0 && res.data?.list?.length) {
          this.carList = res.data.list.map(item => {
            item.distance_desc = item.distance > 1000 ? `${(item.distance/1000).toFixed(1)}km` : `${item.distance.toFixed(0)}m`
            return item
          })
        }
        if (res.errno !== 0) {
          this.triggerError(ERROR.requestError, res)
        }
      } catch (e) {
        this.triggerError(ERROR.networkError, e)
        console.error(e)
      }
      this.requestedCar = true
    },
    checkParams(params) {
      for (let i=0, len=paramsList.length;i<len; i++){
        const param = paramsList[i]
        if (!params[param]) {
          this.triggerError(ERROR.paramsError, param)
          console.warn(`组件【gas-station-list】: 缺少参数 ${param}`)
          return Promise.reject(new Error(`组件【gas-station-list】: 缺少参数 ${param}`))
        }
      }
    },
    footerBtnClick() {
      this.triggerEvent('footerBtnClick', { tab: this.isActive, title: this.isActive === 'gas' ? this.gasTitle : this.carTitle })
    },
    toGuide(e) {
      const item = e.detail
      if (__mpx_mode__ === 'web') {
        if (is('weixin')) {
          window.wx.openLocation({
            latitude: Number(item.latitude),
            longitude: Number(item.longitude),
            name: item.name,
          })
        } else if (is('passenger')) {
          bridge.openPage({
            target: 'native',
            url: build('onetravel://driving/entrance', {
              from_page: 'xiaoju_gas',
              target_page: 'route_select',
              navi_end_lat: Number(item.latitude),
              navi_end_lng: Number(item.longitude),
              navi_end_name: item.name, // 如果按文档 encode IOS下名称显示错误
              navi_end_third_party_id: item.store_id,
            })
          })
        }
      } else {
        wx.openLocation({
          latitude: Number(item.latitude),
          longitude: Number(item.longitude),
          name: item.name,
        })
      }
      this.triggerEvent('toGuide', { title: this.gasTitle })
    },
    triggerError(type, data) {
      this.error = type
      this.triggerEvent(ERROR.name, {
        type,
        data,
      })
    },
  },
})
</script>

<style lang="stylus" scoped>
@font-face {
  font-family: 'UniSansHeavyItalicCAPS';
  src: url('https://img-hxy021.didistatic.com/static/utfe/do1_l1Sw5zCiLssbdzlZQI12');
}
.station
  .header
    display flex
    background-color: rgba(255,157,66,0.70);
    border-top-left-radius: 30rpx
    border-top-right-radius: 30rpx
    overflow: hidden
    background-size: auto 100%
    background-repeat: no-repeat
    // padding 0 38rpx 4rpx
    box-sizing border-box
    height 80rpx
    line-height 80rpx
    font-family: PingFangSC-Medium;
    font-weight: bold
    font-size: 36rpx;
    color: #ffffff;
    font-weight: 500
    letter-spacing: 0;
    margin-bottom: -1px; // iphoneX屏幕 header和content的div有空隙
    .tab
      width: 365rpx
      background-size: auto 100%
      background-repeat: no-repeat
    .tab_left
      padding-left: 40rpx;
      &.active_left
        width: 375rpx
        color: rgba(224,45,24,1);
        background-image url('https://ut-static.udache.com/webx/ut/lvqsyBxf2yErfELWr3R9B.png')
    .tab_right
      text-align center
      &.active_right
        // padding-left: 100rpx;
        width: 462rpx
        color: rgba(224,45,24,1);
        background-image url('https://ut-static.udache.com/webx/ut/6bQ3LIAsp7m_GzaAYxC-C.png')
  .footer
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 26rpx;
    color: #FF4628;
    margin 33rpx 0 35rpx
    .button
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-size: 26rpx;
      color: #B6631D;
    .icon-arrow
      margin-left 8rpx
      width: 0
      height: 0;
      border-left: 20rpx solid red;
      border-bottom: 10rpx solid transparent;
      border-top: 10rpx solid transparent;
  .content
    padding 24rpx 38rpx 4rpx
    background: #FFFFFF;
    border-radius: 0 0 30rpx 30rpx
    .placehoder .item
      height 136rpx
    .item
      padding 48rpx 0 52rpx 0
      border-bottom: 1px dashed #C63200;
      &.no-border
        border-bottom none
      .item-header
        display flex
        margin-bottom 20rpx
        .item-name
          flex 1
        .item-name, .item-distance
          font-family: PingFangSC-Medium;
          font-size: 34rpx;
          font-weight: 600
          color: #1B1B1B;
        .item-distance, .item-guide
          display inline-block
        .item-guide
          font-family: PingFangSC-Regular;
          font-size: 26rpx;
          color: #000000;
          padding-left 18rpx
          .icon-guide
            position relative
            top 2rpx
            right 2rpx
            width 26rpx
      .item-desc
        font-family: PingFangSC-Medium;
        font-weight: 600
        font-size: 22rpx;
        color: #4E4E4E;
        line-height: 21rpx;
      .item-price
        display flex
        align-items: baseline;
        margin-top 32rpx
        color: #B6631D;
        .label
          font-family: PingFangSC-Medium;
          font-weight: 600
          font-size: 22rpx;

        .price-vip > .value
          font-family: UniSansHeavyItalicCAPS;
          font-weight: bold
          font-size: 52rpx;
          color: #FF4628;
          letter-spacing: 0;
          line-height: 52rpx;
          position relative
          bottom -4rpx
          .unit
            padding-right 8rpx
            font-size: 40rpx;
        .price-original
          padding-left 23rpx
          .value
            font-family: PingFangSC-Medium;
            font-weight: 600
            font-size: 22rpx;
          .unit
            padding-right 6rpx
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {
    "gas-list": "./gas-list.mpx",
    "car-wash-list": "./car-wash-list.mpx"
  }
}
</script>
